import { useMemo } from 'react';
import type { RequisitionDto } from '@eombor/contracts';
import { DESKTOP_QUERY, useMediaQuery } from '../../../shared/ui/useMediaQuery.js';
import { useWarehouses } from '../../warehouse/model/warehouse.queries.js';
import { acceptQueueOf, showsAcceptBar } from './accept-queue.js';
import { useInbox } from './requisition.queries.js';

export interface AcceptQueueState {
  /** Qabul qilinadigan talabnomalar — eng yangisi tepada. */
  rows: RequisitionDto[];
  count: number;
  isLoading: boolean;
  /** Suzuvchi tugma chizilsinmi (mobil + navbat bo'sh emas). */
  showBar: boolean;
  /** Ombor nomi identifikator o'rniga. */
  warehouseNames: ReadonlyMap<string, string>;
}

/**
 * QABUL QILISH navbati — bir nechta sahifa uchun BITTA manba.
 *
 * Ro'yxat alohida so'rovdan emas, `useInbox` javobidan ajratiladi.
 * Server «Berildi» qatorlarini allaqachon faqat `requisition.confirm
 * .receipt` egasiga qaytaradi (`requisition/domain/inbox.ts`), ya'ni
 * ikkinchi so'rovning ma'nosi yo'q — u faqat ikkita ro'yxat hosil qilib,
 * ular bir-biridan orqada qolib, son ikki xil chiqishiga olib kelardi.
 *
 * Aynan shu sabab hook boshqaruv paneliga ham to'g'ri keladi: u yerdagi
 * «Mening navbatim» kartochkasi ham `useInbox` dan o'qiydi va ikkovi
 * BIR keshdan — bitta so'rovdan — oziqlanadi.
 */
export const useAcceptQueue = (): AcceptQueueState => {
  const inbox = useInbox();
  const warehouses = useWarehouses({ limit: 200 });
  const mobile = !useMediaQuery(DESKTOP_QUERY);

  const rows = useMemo(() => acceptQueueOf(inbox.data?.items ?? []), [inbox.data]);
  const warehouseNames = useMemo(
    () => new Map((warehouses.data?.items ?? []).map((w) => [w.id, w.name])),
    [warehouses.data],
  );

  return {
    rows,
    count: rows.length,
    isLoading: inbox.isPending,
    showBar: showsAcceptBar({ mobile, count: rows.length }),
    warehouseNames,
  };
};

